import http from '@/utils/http.js'

class Graph {
  flowLog (args) {
    let logType = 'getFlowLog'
    const params = {
      dataId: args.dataId,
      properties: args.properties,
      period: args.period,
      from: args.from,
      to: args.to,
      sort: args.sort,
      timezone: args.timezone,
      fill: false, // データが空の場合、直前のデータで埋めるかどうか
      fillOutOfRange: true, // from、toの範囲外のデータを埋めるかどうか
      firstDayOfWeek: args.firstDayOfWeek
    }
    return this._request(logType, params)
  }

  roRateLog (args) {
    let logType = 'getRoRateLog'
    const params = {
      dataId: args.dataId,
      period: args.period,
      from: args.from,
      to: args.to,
      sort: args.sort,
      timezone: args.timezone,
      fill: false, // データが空の場合、直前のデータで埋めるかどうか
      fillOutOfRange: true, // from、toの範囲外のデータを埋めるかどうか
      firstDayOfWeek: args.firstDayOfWeek
    }
    return this._request(logType, params)
  }

  leakageLog (args) {
    let logType = 'getLeakageLog'
    const params = {
      dataId: args.dataId,
      from: args.from,
      to: args.to,
      sort: args.sort,
      timezone: args.timezone,
      fill: false, // データが空の場合、直前のデータで埋めるかどうか
      fillOutOfRange: true // from、toの範囲外のデータを埋めるかどうか
    }
    return this._request(logType, params)
  }

  waterPressureLog (args) {
    let logType = 'getWaterPressureLog'
    const params = {
      dataId: args.dataId,
      properties: args.properties,
      period: args.period,
      from: args.from,
      to: args.to,
      sort: args.sort,
      timezone: args.timezone,
      fill: false, // データが空の場合、直前のデータで埋めるかどうか
      fillOutOfRange: true, // from、toの範囲外のデータを埋めるかどうか
      firstDayOfWeek: args.firstDayOfWeek
    }
    return this._request(logType, params)
  }

  temperatureLog (args) {
    let logType = 'getTemperatureLog'
    const params = {
      dataId: args.dataId,
      properties: args.properties,
      period: args.period,
      from: args.from,
      to: args.to,
      sort: args.sort,
      timezone: args.timezone,
      fill: false, // データが空の場合、直前のデータで埋めるかどうか
      fillOutOfRange: true, // from、toの範囲外のデータを埋めるかどうか
      firstDayOfWeek: args.firstDayOfWeek
    }
    return this._request(logType, params)
  }

  _request (logType, args) {
    return new Promise((resolve, reject) => {
      http.request('post', '/service2/dashboard/api/graphs/' + logType, args)
        .then((response) => {
          if (response.data.result === 0) {
            resolve(response.data.data)
          } else {
            reject(response.data.result)
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
  }
}

export default Graph



// WEBPACK FOOTER //
// ./src/utils/graph.js